"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_directInsertPortfolioCovenants = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils = __importStar(require("../../utils"));
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Direct Insert Portfolio Covenants`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            creditFacilitySlug: 'CREDIT_FACILITY_SLUG',
            portfolioCovenantsArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER'),
            format: 'columnPerEntry',
            portfolioCovenantKeys: ['PLACEHOLDER'],
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = {
            ...utils.copyNodeConfiguration({
                nodeToCopy,
                isNode,
                nodeType: types_1.nodeType,
                suggestedSerialNumber,
            }),
            portfolioCovenantsArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('PLACEHOLDER'),
        };
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const edgeErrors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: () => true,
        minInputs: 1,
        maxInputs: 1, // only 1 input allowed
        minOutputs: 0,
        maxOutputs: 100,
    });
    return edgeErrors;
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ tape, graph, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'directInsertPortfolioCovenants', `node is not a directInsertPortfolioCovenants, found: [tape.type:${tape.type}]`);
    const { id, artifactSlug, configuration: { portfolioCovenantsArtifactSlug }, } = tape;
    const artifactInputs = utils.getDirectInputsForArtifact({
        targetArtifactId: id,
        ...graph,
    });
    const input = utils.getInputBaseFields({
        artifactInputs,
        inputArtifactSlug: portfolioCovenantsArtifactSlug,
        tapeBuilder,
        errorPrefix: `directInsertPortfolioCovenants: [${artifactSlug}]`,
    });
    if (!input.isValid) {
        return [input.error];
    }
    return utils.validateKeyedEntryFields({
        format: tape.configuration.format,
        keys: tape.configuration.portfolioCovenantKeys,
        recordShape: finley_types_1.PortfolioCovenant.PortfolioCovenantDirectInsertRecordStruct.shape,
        baseFields: input.baseFields,
        errorPrefix: `directInsertPortfolioCovenants: [${artifactSlug}] [inputArtifact:${portfolioCovenantsArtifactSlug}]`,
    });
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_directInsertPortfolioCovenants = {
    nodeTypeText: 'Direct Insert PortCovs',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    badgeTexts: ['DirectInsert'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map